import React from "react";
import styles from './TransitTime.module.scss'
import {getHoursAndMinutes} from 'data/utils/calculators';

export interface ILocationTimeProps {
  timeOfTakeOff: number;
  timeOfLanding: number;
}

const TransitTime = (props: ILocationTimeProps) => (
  <small
    className={styles.TransitTime}
    style={{
      position: 'absolute',
      marginRight: '34%',
      top: -7,
      fontWeight: 400,
      fontSize: '50%',
      width: '36%',
      textAlign: 'center',
    }}
    title="time of flight"
  >{getHoursAndMinutes(props.timeOfTakeOff, props.timeOfLanding)}</small>
);

TransitTime.defaultProps = {};

export default TransitTime;
